import React, { useState, useEffect, useRef } from "react";
import { ReuseInputGroup } from "@locoworks/reusejs-react-input-group";
import { twMerge } from "tailwind-merge";

interface PrimaryInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  form?: any;
  field?: string;
  fieldType?: any;
  placeholder?: string;
  prefix?: string;
  prefixClasses?: string;
  onClickCallback?: Function;
  disabled?: boolean;
  message?: string;
  messageClasses?: any;
  errorMsg?: string;
  errorWithIcon?: boolean;
  onChange?: (e?: any) => void;
  classNames?: string;
  wrapperClasses?: string;
  value?: any;
  reuseinputref?: any;
  defaultValue?: string;
  resetRef?: any;
}

const PrimaryInput: React.FC<PrimaryInputProps> = ({
  form,
  field,
  placeholder,
  prefix,
  prefixClasses = "text-sm text-semibold",
  onClickCallback,
  disabled,
  message,
  messageClasses = "",
  errorMsg,
  onChange,
  classNames,
  wrapperClasses,
  value = "",
  defaultValue,
  resetRef,
  ...rest
}) => {
  const [inFocus, setInFocus] = useState(form.getField(field) ? true : false);

  const defaultClassNames =
    "leading-5 focus:ring-black focus:border-gray-600  outline-none border-gray-300 h-[38px] leading-4 text-sm rounded-md ";
  const finalClassNames = twMerge(
    defaultClassNames,
    classNames,
    errorMsg
      ? "border-sunset-orange-2 border-1 focus:ring-sunset-orange-2 focus:border-0"
      : "focus:ring-black"
  );

  const defaultWrapperClasses = "w-full rounded-xl  mb-4 border-box";
  const finalWrapperClasses = twMerge(defaultWrapperClasses, wrapperClasses);

  const [formattedValue, setFormattedValue] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (resetRef?.current) {
      if (inputRef && inputRef?.current) {
        inputRef.current.value = "";
      }
      setFormattedValue("");
      setInFocus(false);
      resetRef.current = false;
    }
  }, [resetRef?.current]);

  console.log(form.value, field, form.getField(field), ">>>");
  return (
    <div className="flex flex-col">
      <ReuseInputGroup
        defaultValue={form.getField(field)}
        disabled={disabled}
        wrapperClasses={finalWrapperClasses}
        value={form.value.field}
        onChange={(e: any) => {
          form.setField(field, e.target.value);
        }}
        prefix={
          <div className={"text-sm font-medium text-gray-800 " + prefixClasses}>
            {prefix}
          </div>
        }
        onFocus={() => setInFocus(true)}
        className={finalClassNames}
        placeholder={typeof placeholder === "string" ? placeholder : ""}
        reuseinputref={inputRef}
        {...rest}
      />

      {message ? (
        <div
          className={twMerge(
            "flex flex-row pt-2 text-xs" +
              " -mt-6  items-center italic" +
              messageClasses
          )}
        >
          <label className="w-full font-normal text-sm font-inter pl-2 leading-[22px]">
            {message}
          </label>
        </div>
      ) : (
        ""
      )}
      {form.errors.get(field) ? (
        <div className={twMerge("flex flex-row " + " items-center")}>
          <label className="w-full text-red-500 font-normal text-sm font-inter pl-2 leading-[22px]">
            {form?.errors?.get(field) && form.errors.get(field)[0]}
          </label>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default PrimaryInput;
